<template>
  
<div 
  ref="content" 
  :contenteditable="true"
></div>

</template>

<script>
import { mapState, } from 'vuex'

export default {
  name: 'TinyMCE',
  components: {
  },
  props: {
    value: {
      type: String,
    },
    contentType: {
      type: String,
      default: "html-text"
    }
  },
  computed: {},
  data() {
    const route = this.$router.resolve({ 
      name: 'ImageManager',
    })
    return {
      imageManagerHref: route.href,
      instance: null,
    }
  },
  computed: {
    ...mapState({
    }),
  },
  methods: {
    createInstance() {
      if (this.instance) {
        this.instance.destroy()
      }

      const content = this.$refs.content
      if (this.contentType === 'html-text') {
        this.instance = CKEDITOR.inline(content, {
          height: '50px',
          toolbarGroups: [{
            "name": "basicstyles",
              "groups": ["basicstyles"]
            },
            {
              "name": "links",
              "groups": ["links"]
            },
            {
              "name": "paragraph",
              "groups": ["list"]
            },
            {
              "name": "styles",
              "groups": ["styles"]
            },
          ],
          // Remove the redundant buttons from toolbar groups defined above.
          removeButtons: 'Superscript,Anchor,Styles,Specialchar'
        })
      } else if (this.contentType === 'html-article') {
        this.instance = CKEDITOR.inline(content, {
            extraPlugins: 'image2,uploadimage',
            filebrowserBrowseUrl: this.imageManagerHref,
            filebrowserImageBrowseUrl: this.imageManagerHref,
            
        })
      } else {
        throw new Error('Unsupported content type ' + contentType)
      }
      
      this.instance.setData(this.value)
      this.instance.on('change', function(ev) {
        this.$emit('input', ev.editor.getData())
      }.bind(this))
    }
  },
  mounted () {
    this.createInstance()
  },
  destroyed() {
    if (this.instance) {
      this.instance.destroy()
    }
  },
  watch: {
    value(newVal) {
      if (this.instance.getData() !== newVal) {
        this.instance.setData(newVal)
      }
    }
  }
}

</script>